/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~/db/db";

const useSubGrupoMaterial = ({ grupoProduto, formikRef, name = 'subGrupoMaterialId', filialForm, gruposMateriaisDisponiveis, subGrupoMateriaisDisponiveis, replicacao = false }) => {
  const subGrupoMaterialSelect = useSelect("subGrupoMaterial");
  const [subGrupoMaterial, setSubGrupoMaterial] = useState(0);

  const [subGrupoMateriais, setSubGrupoMateriais] = useState([]);

  useEffect(() => {
    const fetchSubGrupoMateriais = async () => {
      let query = db.subGrupoMaterial;
      let wheres = 0;

      if (grupoProduto > 0) {
        query = query.where("grupoMaterialId").equals(grupoProduto);
        wheres++;

        if (filialForm && gruposMateriaisDisponiveis && gruposMateriaisDisponiveis["key-" + grupoProduto] !== undefined) {
          const cur = gruposMateriaisDisponiveis["key-" + grupoProduto].filiais;

          if (cur["key-" + filialForm]) {
            const ids = Object.keys(cur["key-" + filialForm]).map(e => parseInt(e));
            if (ids.length > 0) {
              query = query.and(c => ids.includes(c.id));
              wheres++;
            }
          }
        }
      }

      if (gruposMateriaisDisponiveis) {
        if (wheres > 0) {
          query = query.and(c => gruposMateriaisDisponiveis.includes(c.grupoMaterialId));
        }
        else {
          query = query.where("grupoMaterialId").anyOf(gruposMateriaisDisponiveis);
        }
      }

      if (subGrupoMateriaisDisponiveis) {
        if (wheres > 0) {
          query = query.and(c => subGrupoMateriaisDisponiveis.includes(c.id));
        }
        else {
          query = query.where("id").anyOf(subGrupoMateriaisDisponiveis);
        }
      }

      if (replicacao) {
        query = query.filter(a => a.replicacaoAtiva !== false);
      }

      //  if (!grupoProduto) return;

      const subGrupos = [];
      await query.each((subGrupo) => {
        subGrupos.push(subGrupo);
      });

      setSubGrupoMateriais(subGrupos);
    };

    fetchSubGrupoMateriais();
  }, [grupoProduto, filialForm, gruposMateriaisDisponiveis, subGrupoMateriaisDisponiveis]);


  const optionSubGrupoMateriais = useMemo(() => prepareForOptions(subGrupoMateriais, 'nome', 'id'), [subGrupoMateriais]);

  function onChangeSubGrupoMaterial(e) {
    subGrupoMaterialSelect.upDateValue(e.value);
    subGrupoMaterialSelect.upDateDefaultValue(e || "");
    if (formikRef?.current) {
      formikRef.current.setFieldValue(name, e.value);
      setTimeout(() => formikRef.current.setFieldTouched(name, true));
    }
    setSubGrupoMaterial(e.value);
  }

  function SetSelectSubGrupoMaterial(id) {
    const subGrupoMaterial = optionSubGrupoMateriais.find((o) => o.value === id);
    if (subGrupoMaterial) {
      onChangeSubGrupoMaterial(subGrupoMaterial);
    }
  }

  function CleanForFilter(option) {
    onChangeSubGrupoMaterial(option);
  }

  const checkSubGrupoMaterialExists = async () => {
    const exists = await db.produtos.where("grupoMaterialId").equals(grupoProduto).and(c => c.id == subGrupoMaterial).count();

    if (exists == 0) {
      onChangeSubGrupoMaterial({
        value: null
      });
    }
  }

  useEffect(() => {
    if (grupoProduto && grupoProduto != 0 && subGrupoMaterial && subGrupoMaterial != 0) {

      checkSubGrupoMaterialExists();
    }
  }, [grupoProduto, subGrupoMaterial]);

  return {
    subGrupoMateriais,
    optionSubGrupoMateriais,
    onChangeSubGrupoMaterial,
    SetSelectSubGrupoMaterial,
    subGrupoMaterial,
    subGrupoMaterialSelect,
    setSubGrupoMaterial,
    CleanForFilter,
  };
}

export default useSubGrupoMaterial;